class SpecificExceptions extends Error {
  constructor(code, message) {
    // console.log("SpecificExceptions :: message => "+message)
    // console.log("SpecificExceptions :: code => "+code)
    super();
    this.code = code;
    this.message = message;
  }
}
export default SpecificExceptions;